import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { getCurrentUser, getToken, generatePermission } from '../utils/auth'

const registerInfo = JSON.parse(localStorage.getItem('registerInfo') || '{}')
const currentUser: any = getCurrentUser()
const permissions = JSON.parse(localStorage.getItem('permissions') || '{}')

const initialState = {
  currentUser,
  token: getToken(),
  register: registerInfo,
  permissions,
}

const user = (state = initialState, action: PayloadAction<any>) => {
  switch (action.type) {
    case 'user/register':
      state = {
        ...state,
        register: action.payload,
      }
      return state
    case 'user/found':
      const { userInfo, token, subjectList } = action.payload
      const currentUser = {
        ...userInfo,
        subject: subjectList.length === 0 ? 'cue_tech' : subjectList.length === 1 ? subjectList[0] : 'cue_tech', // 默认'cue_tech' 有多个主体时是'cue_tech'
        subjectList,
        username: userInfo.userName,
      }

      localStorage.setItem('currentUser', JSON.stringify(currentUser))
      localStorage.setItem('token', token)

      state = {
        ...state,
        currentUser,
        token,
      }
      return state
    case 'user/permissions':
      const permissions = generatePermission(action.payload)
      state = {
        ...state,
        permissions,
      }
      localStorage.setItem('permissions', JSON.stringify(permissions))
      return state
    case 'user/update':
      const { status, agree, unauthorized } = action.payload

      state = {
        ...state,
        currentUser: {
          ...state.currentUser,
          status,
          agree,
          unauthorized,
        },
      }
      localStorage.setItem('currentUser', JSON.stringify(state.currentUser))
      return state
    case 'user/updateToken':
      state = {
        ...state,
        token: action.payload,
      }
      localStorage.setItem('token', action.payload)
      return state
    case 'user/updateSubject':
      const { subject, payPlatform } = action.payload
      state = {
        ...state,
        currentUser: {
          ...state.currentUser,
          subject,
          payPlatform,
        },
      }
      localStorage.setItem('currentUser', JSON.stringify(state.currentUser))
      return state
    default:
      return state
  }
}

export default user
